module.exports = __webpack_public_path__ + "static/media/liquid_transport_pipline.09011fc2.png";